import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type {
  Tier,
  TierProgramRow,
  TierProgramMatrixRow,
  TierProgramCell,
} from "@colab/shared";

// GET /api/portal/tier-program — aggregated default tier program + tiers +
// matrix (requirements/benefits rows + cells) + the partner's current
// assignment. Aggregated server-side because the reads chain on the program
// existing; if no default program exists, the route returns empty arrays and
// the LevelUpWidget renders nothing.
export type PortalTierProgramResponse = {
  program: TierProgramRow | null;
  tiers: Tier[];
  rows: TierProgramMatrixRow[];
  cells: TierProgramCell[];
  currentTierId: string | null;
};

export function useTierProgram() {
  return useQuery<PortalTierProgramResponse, ApiClientError>({
    queryKey: queryKeys.portal.tierProgram(),
    queryFn: () => apiFetch<PortalTierProgramResponse>("/portal/tier-program"),
  });
}
